import { render, staticRenderFns } from "./LawGuideEdit.vue?vue&type=template&id=06696cb5&"
import script from "./LawGuideEdit.vue?vue&type=script&lang=js&"
export * from "./LawGuideEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports